import { ParsedLesson } from './../types/parsedLesson';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';

export default function useCurrentLesson(lessons: ParsedLesson[]) {
  const router = useRouter();
  const [selectedLessonIndex, setSelectedLessonIndex] = useState<
    number | undefined
  >();

  useEffect(() => {
    // NOTE: https://github.com/vercel/next.js/discussions/11484
    if (router.isReady) {
      setSelectedLessonIndex(
        Math.min(lessons.length - 1, Number(router.query.lesson) - 1),
      );
    }
  }, [router.query.lesson]);

  return { selectedLessonIndex };
}
